/**
 * `addon_added` for the checkout surfaces (standalone /checkout page and the LP
 * island). It is the only writer of lp_visitor_sessions.addons_added, so a
 * surface that lets the buyer tick an add-on without emitting it reports 0
 * add-ons on orders that carry them: the /checkout page (every scroll_direct
 * LP checks out there) never emitted it until 2026-10-20.
 *
 * Fires when the buyer ADDS an add-on, at most once per add-on per page view,
 * so toggling one off and on again cannot inflate the counter.
 */
export function shouldTrackAddonAdded(
  selected: ReadonlySet<string>,
  alreadyTracked: Set<string>,
  addonId: string
): boolean {
  if (!addonId || selected.has(addonId) || alreadyTracked.has(addonId)) return false;
  alreadyTracked.add(addonId);
  return true;
}
